import type { VoidFunctionComponent } from 'react';

import { LabeledToggle } from '../../generic/Forms/LabeledToggle';

type Props = {
  isEnabled: boolean;
  onToggle: (isChecked: boolean) => void;
};

const CVEFilterComponent: VoidFunctionComponent<Props> = ({
  isEnabled,
  onToggle,
}) => (
  <LabeledToggle
    id="security-policy-show-disputed-cves"
    label="Show Disputed CVEs"
    isChecked={isEnabled}
    onChange={onToggle}
  />
);

export default CVEFilterComponent;
